import { useNewTranslations } from '@/common/translations';
import { Jersey } from '@/ui/components';
import StadiumImage from '../../assets/stadium.png';
import type { FirstTopGoalscorerProps } from './TopGoalscorers.types';

const BG_GRADIENT =
  'radial-gradient(124.86% 42.69% at 39.25% 50%, rgba(0, 0, 0, 0.80) 0%, rgba(0, 0, 0, 0.24) 100%)';

export default function FirstTopGoalscorer(props: FirstTopGoalscorerProps) {
  const { jerseySrc, topGoalscorer, isAway = false } = props;
  const { name, goals, position, flagSrc } = topGoalscorer;

  const translate = useNewTranslations();

  const goalsBackgroundClass = isAway ? 'bg-pmw-bar-orange-light' : 'bg-pmw-bar-blue-light';

  return (
    <div
      className="w-full h-[90px] p-2 flex justify-center gap-2 rounded-[12px] overflow-hidden bg-cover bg-center"
      style={{ backgroundImage: `${BG_GRADIENT}, url(${StadiumImage})` }}
    >
      <Jersey size={109} jerseySrc={jerseySrc} />
      <div className="flex-1 self-center flex flex-col text-white">
        <span className="text-[14px] leading-[20px]">{name}</span>
        {position && (
          <span className="flex items-center gap-1 text-[10px] leading-[16px]">
            {flagSrc && (
              <img className="w-[12px] h-[12px]" src={flagSrc} alt="" aria-hidden="true" />
            )}
            <span>{position}</span>
          </span>
        )}
      </div>
      <div
        className={`w-[50px] h-[50px] p-2 flex flex-col items-center justify-center self-center rounded-[12px] text-white ${goalsBackgroundClass}`}
      >
        <span className="font-unibet text-[24px] leading-[24px]">{goals}</span>
        <span className="font-medium text-[12px] leading-[16px]">
          {translate('PreMatchStats.Goals')}
        </span>
      </div>
    </div>
  );
}
